<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between">
          <h1>Все категории</h1>
          <va-button color="info" @click="showModal = true">
            Добавить категорию
          </va-button>
        </div>
      </va-card>

      <categories-table class="mb-4" :categories="categories" />
      <va-modal v-model="showModal" hide-default-actions>
        <category-form
          mode="create"
          @close="showModal = false"
        />
      </va-modal>
    </va-inner-loading>
  </div>
</template>

<script>
import CategoryForm from "../../components/categories/CategoryForm.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import CategoriesTable from "../../components/categories/categories-table.vue";
export default {
  name: "Categories",
  components: { CategoryForm, CategoriesTable },
  data() {
    return {
      showModal: false,
    };
  },
  async created() {
    await this.getCategories();
  },
  computed: {
    ...mapState("categories", ["categories"]),
    ...mapGetters({
      loader: "isLoading",
    }),
  },
  methods: {
    ...mapActions({
      getCategories: "categories/getCategories",
    }),
  },
};
</script>

<style></style>
